// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BillingSubscriptions } from '../../../../types/server/modules/billing/subscriptions';

export type * from '../../../../types/server/modules/billing/subscriptions';

export const createSubscriptions = ( requests: Requests ): BillingSubscriptions => ({
  BillingProducts: ( params, onChange ) => {
          return requests.subscribe( `/billing/products/:id?`, params, 'BillingProducts', onChange );
          }
});
